import { createSelector } from '@reduxjs/toolkit';
import { getFromImmutableState } from '../../../../utils/immutableUtils';

const _getExperiences = (state) => state.get('experiences');
export const getExperiences = getFromImmutableState(_getExperiences);
export const getHotelExperiences = createSelector(
  getExperiences,
  (experiences) =>
    experiences
      .filter(({ enabled }) => enabled)
      .map(
        ({
          description: fullDescription,
          full_name: title,
          images,
          short_description: description,
          yt_video_id: videoFrame,
        }) => {
          const gallery = images.map(
            (
              { fullImage, id, smallImage, thumbImage, thumbImageX2 },
              index,
            ) => {
              const special =
                index === 0 && videoFrame
                  ? {
                      id,
                      content: videoFrame,
                      title,
                      extra: {
                        is_video: true,
                      },
                    }
                  : { id };

              return {
                images: {
                  fullImage,
                  smallImage,
                  thumbImage,
                  thumbImageX2,
                },
                special,
              };
            },
          );

          return {
            title,
            fullDescription,
            description,
            gallery,
          };
        },
      ),
);
